import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface AuthSession {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
}

interface SessionResponse {
  session: AuthSession | null;
}

export class AuthApi {
  protected endpoint = '/auth';

  constructor(private readonly http: HttpClient) {}

  public signup(email: string, password: string): Observable<SessionResponse> {
    return this.http.post<SessionResponse>(`${this.endpoint}/signup`, {
      email,
      password,
    });
  }

  public login(email: string, password: string): Observable<SessionResponse> {
    return this.http.post<SessionResponse>(`${this.endpoint}/login`, {
      email,
      password,
    });
  }

  public logout(accessToken: string): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.endpoint}/logout`, {
      access_token: accessToken,
    });
  }

  public resetPassword(email: string): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(
      `${this.endpoint}/reset-password`,
      { email },
    );
  }

  public refresh(refreshToken: string): Observable<SessionResponse> {
    return this.http.post<SessionResponse>(`${this.endpoint}/refresh`, {
      refresh_token: refreshToken,
    });
  }

  public verifyEmail(tokenHash: string): Observable<SessionResponse> {
    return this.http.post<SessionResponse>(`${this.endpoint}/verify-email`, {
      token_hash: tokenHash,
    });
  }

}
